<div class="mobile-header">
  <ng-container i18n>
    <span class="h1-style">Select rooms</span>
  </ng-container>
  <a [routerLink]="['../']" [queryParamsHandling]="'preserve'">
    <svg-icon style="height: 18.2px" [svgStyle]="{'width.px': 18.2, 'height.px': 18.2}" src="/assets/icons/arrow_left.svg"></svg-icon>
  </a>
</div>

<div class="hostel-details">
  <div class="left">
    <div class="image">
      <ng-container *ngIf="hostel?.propertyImages?.[0]?.fileName else default_image">
        <img ngOptimizedImage class="main_image" [ngSrc]="hostel?.propertyImages[0].fileName" [width]="98" [height]="98" alt="">
      </ng-container>
      <ng-template #default_image>
        <svg-icon [svgStyle]="{'width.px': 98, 'height.px': 98}" src="/assets/icons/large_bed.svg"></svg-icon>
      </ng-template>
    </div>
  </div>
  <div class="right">
    <div class="name">
      {{ hostel?.name }}
    </div>
    <div class="description">
    </div>
  </div>
</div>

<div class="dates-guests">
  <div class="dates">
    <div class="top">
      <div class="heading">
        <ng-container i18n>Dates</ng-container>
      </div>
      <div class="edit" (click)="openBottomSheet()">
        Edit
      </div>
    </div>
    <div class="bottom">
      {{ checkInDate?.slice(0, 10) | date : 'MMM d' }} - {{ checkOutDate?.slice(0, 10) | date : 'MMM d' }}
    </div>
  </div>

  <div class="guests">
    <div class="top">
      <ng-container i18n>
        Guests
      </ng-container>
      <div class="edit" (click)="toggleNoOfGuestsInput()">
        Edit
      </div>
    </div>
  </div>
  <div class="bottom">
    <ng-container *ngIf="!editingNoOfGuests">
      {{ noOfGuests === 1 ? '1 guest' : noOfGuests + ' guests'}}
    </ng-container>
    <ng-container *ngIf="editingNoOfGuests">
      <input class="theme-input" #noOfGuestsInput [(ngModel)]="noOfGuests" type="number" (outsideClick)="editingNoOfGuests = false; search()" (keyup.enter)="editingNoOfGuests = false; search()">
    </ng-container>
  </div>
</div>

<!-- Booking error message -->
<div class="booking-error" *ngIf="bookingError">
  <div class="error-content">
    <svg-icon 
      [svgStyle]="{'width.px': 20, 'height.px': 20}" 
      src="/assets/icons/info.svg">
    </svg-icon>
    <span>{{ bookingError }}</span>
  </div>
</div>

<div class="rooms">
  <div class="rooms-booking">
    <app-room-list [rooms]="rooms" [hostel]="hostel" [isLoading]="loading"></app-room-list>
  </div>
</div>

<ng-container *ngIf="!bottomSheetOpen">
  <app-room-selection-footer
    [total]="total"
    [isLoading]="isBookingLoading"
    (reserve)="goToBooking()">
  </app-room-selection-footer>
</ng-container>

<ng-container *ngIf="bottomSheetOpen">
  <app-when-mobile-scroll
    [unavailableDates]="unavailableDates"
    (close)="closeBottomSheet()">
  </app-when-mobile-scroll>
</ng-container>
<!-- todo allow edit guest # -->
